package com.anjuros.website.redesign.sections.portal

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdEyebrow
import com.anjuros.website.redesign.components.RdLede
import com.anjuros.website.redesign.components.RdPicture
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.styles.PortalClientsGridStyle
import com.anjuros.website.redesign.styles.PortalClientsStyle
import com.anjuros.website.redesign.styles.PortalStatsStyle
import com.anjuros.website.redesign.styles.RdH2Style
import com.anjuros.website.redesign.styles.RdHeroCopyStyle
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.util.RdImage
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private val Stats = listOf(
    RdText.PORTAL_STAT1_TITLE to RdText.PORTAL_STAT1_TEXT,
    RdText.PORTAL_STAT2_TITLE to RdText.PORTAL_STAT2_TEXT,
    RdText.PORTAL_STAT3_TITLE to RdText.PORTAL_STAT3_TEXT,
    RdText.PORTAL_STAT4_TITLE to RdText.PORTAL_STAT4_TEXT,
)

/** Dark band: client history and business statistics. */
@Composable
fun PortalClientsSection() {
    RdSection(
        id = "clients",
        labelledBy = "clients-h",
        modifier = RdSectionStyle.toModifier().then(PortalClientsStyle.toModifier()),
        wrapModifier = PortalClientsGridStyle.toModifier(),
    ) {
        RdPicture(RdImage.PORTAL_PHONE_CLIENTS, LocalText(RdText.PORTAL_CLIENTS_IMAGE_ALT))
        Div(RdHeroCopyStyle.toModifier().toAttrs()) {
            RdEyebrow(RdText.PORTAL_CLIENTS_EYEBROW)
            H2(RdH2Style.toModifier().id("clients-h").toAttrs()) { Text(LocalText(RdText.PORTAL_CLIENTS_TITLE)) }
            RdLede(RdText.PORTAL_CLIENTS_LEDE)
            Div(PortalStatsStyle.toModifier().toAttrs()) {
                Stats.forEach { (title, text) ->
                    Div {
                        B { Text(LocalText(title)) }
                        Span { Text(LocalText(text)) }
                    }
                }
            }
        }
    }
}
